export const BILLING_PLAN_LIST_REQUEST = 'BILLING_PLAN_LIST_REQUEST';
export const BILLING_PLAN_LIST_SUCCESS = 'BILLING_PLAN_LIST_SUCCESS';
export const BILLING_PLAN_LIST_FAIL = 'BILLING_PLAN_LIST_FAIL';

export const BILLING_PLAN_DETAILS_REQUEST = 'BILLING_PLAN_DETAILS_REQUEST';
export const BILLING_PLAN_DETAILS_SUCCESS = 'BILLING_PLAN_DETAILS_SUCCESS';
export const BILLING_PLAN_DETAILS_FAIL = 'BILLING_PLAN_DETAILS_FAIL';
export const BILLING_PLAN_DETAILS_RESET = 'BILLING_PLAN_DETAILS_RESET';

export const BILLING_PLAN_CREATE_REQUEST = 'BILLING_PLAN_CREATE_REQUEST';
export const BILLING_PLAN_CREATE_SUCCESS = 'BILLING_PLAN_CREATE_SUCCESS';
export const BILLING_PLAN_CREATE_FAIL = 'BILLING_PLAN_CREATE_FAIL';
export const BILLING_PLAN_CREATE_RESET = 'BILLING_PLAN_CREATE_RESET';

export const BILLING_PLAN_UPDATE_REQUEST = 'BILLING_PLAN_UPDATE_REQUEST';
export const BILLING_PLAN_UPDATE_SUCCESS = 'BILLING_PLAN_UPDATE_SUCCESS';
export const BILLING_PLAN_UPDATE_FAIL = 'BILLING_PLAN_UPDATE_FAIL';
export const BILLING_PLAN_UPDATE_RESET = 'BILLING_PLAN_UPDATE_RESET';

export const BILLING_PLAN_DELETE_REQUEST = 'BILLING_PLAN_DELETE_REQUEST';
export const BILLING_PLAN_DELETE_SUCCESS = 'BILLING_PLAN_DELETE_SUCCESS';
export const BILLING_PLAN_DELETE_FAIL = 'BILLING_PLAN_DELETE_FAIL';

export const BILLING_PLAN_DTO_REQUEST = 'BILLING_PLAN_DTO_REQUEST';
export const BILLING_PLAN_DTO_SUCCESS = 'BILLING_PLAN_DTO_SUCCESS';
export const BILLING_PLAN_DTO_FAIL = 'BILLING_PLAN_DTO_FAIL';
export const BILLING_PLAN_DTO_RESET = 'BILLING_PLAN_DTO_RESET';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'; 